import { render } from "./InternationalizationManagement.vue?vue&type=template&id=3eb2e51d&ts=true"
import script from "./InternationalizationManagement.vue?vue&type=script&lang=ts"
export * from "./InternationalizationManagement.vue?vue&type=script&lang=ts"

import "./InternationalizationManagement.vue?vue&type=style&index=0&id=3eb2e51d&lang=scss"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__